export enum ProductType {
    Life = "life",
    Health = "health",
    Trauma = "trauma",
    Mortgage = "mortgage",
    Income = "income",
    WaiverOfPremium = "wop"
}

export type ClientProductTypes =
    | ProductType.Life
    | ProductType.Health
    | ProductType.Trauma
    | ProductType.Income
    | ProductType.Mortgage;

// This list is used as the basis for ordering the products
export const ClientProductTypesList: ClientProductTypes[] = [
    ProductType.Life,
    ProductType.Trauma,
    ProductType.Health,
    ProductType.Income,
    ProductType.Mortgage
];

export const isClientProductType = (
    product: ProductType
): product is ClientProductTypes => {
    return ClientProductTypesList.some((s) => s === product);
};

export default ProductType;
